export const storeToken = (token: string) => {
	localStorage.setItem('auth_token', token)
}

export const removeToken = () => {
	localStorage.removeItem('auth_token')
}

export const getToken = (): string | null => {
	if (typeof window === 'undefined') return null
	return localStorage.getItem('auth_token')
}
